// Nota: Este é um método simples de hash usando base64.
// Em produção, você deve usar bcrypt ou outro algoritmo mais seguro.
export function hashPassword(password) {
  try {
    return btoa(password);
  } catch (error) {
    console.error('Erro ao criar hash da senha:', error);
    throw error;
  }
}

export function decodePassword(hashedPassword) {
  try {
    return atob(hashedPassword);
  } catch (error) {
    console.error('Erro ao decodificar senha:', error);
    return 'Erro ao decodificar senha';
  }
} 